export const ACTIVE_RETAILER_KEY = "retailer";

export const RETAILER_PAGE_SEARCH_PARAM = "page";

export const MAPBOX_INITIAL_CENTER: [number, number] = [10.7804, 59.9002];
export const MAPBOX_INITIAL_ZOOM = 10.12;
